module.exports = __webpack_public_path__ + "static/media/timer_FILL0_wght400_GRAD0_opsz24.fe2a3a5f.svg";